<template>
  <div class="container">
    <div v-show="isVisible" class="my-xl-3 py-xl-3" :class="{

        'col-lg-12': true

    }" >

    <!--checkbox-->
    <div class="row justify-content-center" >
        <div class="col col-auto">
          <label class="form-label" > <input type="checkbox" v-model="notChecked" id="checkbox"><span style="margin-right: 10px"></span>zapoznałam/em się z umowa pożyczki oraz akceptuję jej warunki </label>
        </div>
    </div>

      <!--button-->
    <div class="row justify-content-center">
        <div class="col col-auto"><!--
          <button ref="submit" key="sign-button" class="SignContractButton" :disabled="!isDisabled"  @click="signContract"> {{ label }} </button>-->
          <a  key="btn-next"  :class="{
                                  disabled:!isDisabled
                                }"

              class="bubbly-button mybutton btn btn-outline-primary btn-lg me-2"
             @click="signContract" 

              > {{ label }}</a>










        </div>
    </div>


<!-- <main>
<div class="button" @click="onSubmit">
    <div class="text" >Submit</div>
  </div>


  <div class="progress-bar"></div>
  <svg x="0px" y="0px"
     viewBox="0 0 25 30" style="enable-background:new 0 0 25 30;">
    <path ref="check" class="check st0" d="M2,19.2C5.9,23.6,9.4,28,9.4,28L23,2"/>
  </svg>
</main> -->




    </div>
  </div>
</template>

<script>


    import anime from 'animejs/lib/anime.es.js';



    export default {
        name: "SignContract",

        computed: {


            isDisabled(){
                return this.notChecked;
            }

        },


        data(){
            return {

                notChecked: false,

                isVisible: true,


                basicTimeline: anime.timeline({
                  autoplay: false
                })

            }
        },


        props: {

            loan_id: {
                type: String,
                required: false
            },


            label: {
                type: String,
                required: true
            }

        },



        methods: {


            signContract(){


                //this.basicTimeline.play();
                this.$emit('signed', this.loan_id);

            },


            onSubmit(){

               // alert('click')
//console.log('timeline is  ')

          //      console.log(this.basicTimeline)


              //  this.basicTimeline.play();


            }




        },





        created() {


            this.listen('visibility', (bind, checked ) => {

                bind.split(',').indexOf(this.name) > -1
                    && (this.isVisible = checked);
            });




        },

        mounted(){

            var animateButton = function(e) {

              e.preventDefault;
              //reset animation
              e.target.classList.remove('animate');
              
              e.target.classList.add('animate');
              setTimeout(function(){
                e.target.classList.remove('animate');
              },700);
            };

            var bubblyButtons = document.getElementsByClassName("bubbly-button");

            for (var i = 0; i < bubblyButtons.length; i++) {
              bubblyButtons[i].addEventListener('click', animateButton, false);
            }




          /*  var pathEls = this.$refs['check']; //$(".check");
            for (var i = 0; i < pathEls.length; i++) {
              var pathEl = pathEls[i];
              var offset = anime.setDashoffset(pathEl);
              pathEl.setAttribute("stroke-dashoffset", offset);
            }*/

            this.basicTimeline
             /* .add({
                targets: ".text",
                duration: 1,
                opacity: "0"
              })*/
              .add({
                targets: this.$refs['submit'], //".button",
                duration: 1300,
                height: 20,
                width: 300,
                backgroundColor: "#2B2D2F",
                border: "1",
                borderRadius: 100
              });

             /* .add({
                targets: ".progress-bar",
                duration: 2000,
                width: 300,
                easing: "linear"
              })
              .add({
                targets: ".button",
                width: 0,
                duration: 1
              })
              .add({
                targets: ".progress-bar",
                width: 80,
                height: 80,
                delay: 500,
                duration: 750,
                borderRadius: 80,
                backgroundColor: "#71DFBE"
              })
              .add({
                targets: pathEl,
                strokeDashoffset: [offset, 0],
                duration: 200,
                easing: "easeInOutSine"
              });*/

/*$(".button").click(function() {
  basicTimeline.play();
});

$(".text").click(function() {
  basicTimeline.play();
});*/







        }
    }
</script>


<style scoped>
    a{
      width: 300px;
      height: 55px;
      vertical-align: middle;
      text-align: center;
      line-height: 35px;
    }

  .btn-outline-primary,
  .btn-outline-primary.disabled {
    background: linear-gradient(90deg,#fbc566,#f3971a);
  }

  .btn-outline-primary:hover {
    box-shadow: inset -400px 0 0 0 #f57e18;
  }

.btn {
    color: #fff;
    font-size: 1.3rem;
    text-transform: uppercase;
}
  
.mybutton {



    cursor:pointer;
    min-width:160px;
    font-size: 16px;
    padding: 20px 40px;
    transition: ease-out 1s;
    line-height: 16px;

    border-radius:10px !important;
    border:0px;

    margin: 0 .5rem;

}

  @media (max-width:481px){
    a{
      width: 240px;
      height:55px;
      display: inline-block;
      vertical-align: middle;
      text-align: center;
      line-height: 35px;
    }
  }







.bubbly-button:focus {
  outline: 0;
}
.bubbly-button:before, .bubbly-button:after {
  position: absolute;
  content: "";
  display: block;
  width: 140%;
  height: 100%;
  left: -20%;
  z-index: -1000;
  transition: all ease-in-out 0.5s;
  background-repeat: no-repeat;
}


.bubbly-button:before {
  display: none;
  top: -75%;
  background-image: radial-gradient(circle, #f57e18 20%, transparent 20%), radial-gradient(circle, transparent 20%, #f57e18 20%, transparent 30%), radial-gradient(circle, #f57e18 20%, transparent 20%), radial-gradient(circle, #f57e18 20%, transparent 20%), radial-gradient(circle, transparent 10%, #f57e18 15%, transparent 20%), radial-gradient(circle, #f57e18 20%, transparent 20%), radial-gradient(circle, #f57e18 20%, transparent 20%), radial-gradient(circle, #f57e18 20%, transparent 20%), radial-gradient(circle, #f57e18 20%, transparent 20%);
  background-size: 10% 10%, 20% 20%, 15% 15%, 20% 20%, 18% 18%, 10% 10%, 15% 15%, 10% 10%, 18% 18%;
}
.bubbly-button:after {
  display: none;
  bottom: -75%;
  background-image: radial-gradient(circle, #f57e18 20%, transparent 20%), radial-gradient(circle, #f57e18 20%, transparent 20%), radial-gradient(circle, transparent 10%, #f57e18 15%, transparent 20%), radial-gradient(circle, #f57e18 20%, transparent 20%), radial-gradient(circle, #f57e18 20%, transparent 20%), radial-gradient(circle, #f57e18 20%, transparent 20%), radial-gradient(circle, #f57e18 20%, transparent 20%);
  background-size: 15% 15%, 20% 20%, 18% 18%, 20% 20%, 15% 15%, 10% 10%, 20% 20%;
}
.bubbly-button:active {
  transform: scale(0.9);
  background-color: #e60074;
  box-shadow: 0 2px 25px rgba(255, 0, 130, 0.2);
}
.bubbly-button.animate:before {
  display: block;
  animation: topBubbles ease-in-out 0.75s forwards;
}
.bubbly-button.animate:after {
  display: block;
  animation: bottomBubbles ease-in-out 0.75s forwards;
}

@keyframes topBubbles {
  0% {
    background-position: 5% 90%, 10% 90%, 10% 90%, 15% 90%, 25% 90%, 25% 90%, 40% 90%, 55% 90%, 70% 90%;
  }
  50% {
    background-position: 0% 80%, 0% 20%, 10% 40%, 20% 0%, 30% 30%, 22% 50%, 50% 50%, 65% 20%, 90% 30%;
  }
  100% {
    background-position: 0% 70%, 0% 10%, 10% 30%, 20% -10%, 30% 20%, 22% 40%, 50% 40%, 65% 10%, 90% 20%;
    background-size: 0% 0%, 0% 0%, 0% 0%, 0% 0%, 0% 0%, 0% 0%;
  }
}
@keyframes bottomBubbles {
  0% {
    background-position: 10% -10%, 30% 10%, 55% -10%, 70% -10%, 85% -10%, 70% -10%, 70% 0%;
  }
  50% {
    background-position: 0% 80%, 20% 80%, 45% 60%, 60% 100%, 75% 70%, 95% 60%, 105% 0%;
  }
  100% {
    background-position: 0% 90%, 20% 90%, 45% 70%, 60% 110%, 75% 80%, 95% 70%, 110% 10%;
    background-size: 0% 0%, 0% 0%, 0% 0%, 0% 0%, 0% 0%, 0% 0%;
  }
}




</style>



// WEBPACK FOOTER //
// src/components/SignContract.vue